import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import IconRaw from "module-common/Icon";

export default class Image extends Component {
  static propTypes = {
    url: PropTypes.string,
    onRemove: PropTypes.func
  };

  render() {
    const { url, onRemove } = this.props;
    return (
      <Wrapper url={url}>
        <Icon name="x-button-gray" onClick={onRemove} />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  position: relative;
  width: 50px;
  height: 45px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-color: gray;
  border-radius: 3px;
  margin-right: 10px;
  margin-top: 6px;
  margin-bottom: 6px;
  ${props =>
    props.url &&
    css`
      background-image: url(${props.url});
    `};
`;
const Icon = styled(IconRaw)`
  position: absolute;
  top: -5px;
  right: -10px;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/footer/Image.js